// Shallow-merges the stored Spanish copy of a CMS page over the English
// source. The backend writes the translation to `content.i18n.es` with the
// same top-level keys, so one spread is enough.
export function localizedContent(content, lang) {
  const base = content || {};
  if (lang !== "es") return base;
  const es = base.i18n?.es;
  if (!es || typeof es !== "object") return base;
  return { ...base, ...es };
}

// True when a Spanish copy exists for this page.
export function hasSpanish(content) {
  const es = content?.i18n?.es;
  return !!es && typeof es === "object" && Object.keys(es).length > 0;
}

// The page object handed to the renderer / builder for a given language.
export function localizedPage(page, lang) {
  if (!page) return page;
  return { ...page, content: localizedContent(page.content, lang) };
}
